export default [
    {
        path: 'role/list',
        name: 'organization_role_list',
        meta: { isCache: true, icon: 'md-transgender', hideInMenu: false },
        component: () => import('@/views/organization/role/role-list.vue'),
    },
    {
        path: 'role/add',
        name: 'organization_role_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/organization/role/role-add.vue'),
    },
    {
        path: 'role/edit/:id',
        name: 'organization_role_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/organization/role/role-edit.vue'),
    },
    {
        path: 'role/detail/:id',
        name: 'organization_role_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/organization/role/role-detail.vue'),
    },
];
